import {useEffect, useRef} from 'react';

function useInterval(callback, interval, dependencies) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            if (interval !== null) {
                if (typeof savedCallback.current === 'function') {
                    savedCallback.current();
                }
            }
        }

        tick();
        //console.log("Interval", interval);
        if (interval !== null) {
            let id = setInterval(tick, interval);
            return () => clearInterval(id);
        }
    }, [...dependencies, interval]);
}

export {useInterval};